export interface BannerState {
  hasBanner: boolean;
};

export enum ActionTypes {
  SET_HAS_BANNER = 'banner/SET_HAS_BANNER',
};

export interface SetHasBanner {
  type: ActionTypes.SET_HAS_BANNER;
  hasBanner: boolean
};

export type Action = SetHasBanner
